import React, { useState, useEffect } from 'react';
import API from '../../api/api';

interface Coupon {
  code: string;
  createdAt: string;
  createdBy: string;
  expiresAt: string;
  maxUses: number;
}

const CouponManagement: React.FC = () => {
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showCode, setShowCode] = useState<boolean[]>([]);
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const [newCoupon, setNewCoupon] = useState({
    code: '',
    expiresAt: '',
    maxUses: 1
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const response = await API.get('/subscription/coupon');
      setCoupons(response?.data.data);
      setShowCode(new Array(response?.data.data.length).fill(false));

    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to fetch coupons');
    }
  };

  const handleCreateCoupon = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await API.post('/subscription/create-coupon', newCoupon);
      setShowCreateForm(false);
      setNewCoupon({ code: '', expiresAt: '', maxUses: 1 });
      fetchCoupons();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to create coupon');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = (index: number, text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };


  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Coupon Management</h2>
        <button
          className="btn btn-primary"
          onClick={() => setShowCreateForm(true)}
        >
          <i className="fas fa-plus me-2"></i>
          Create New Coupon
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {/* Coupon List */}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Code</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Expires At</th>
              <th>Max Uses</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((coupon, index) => {
              console.log("coupoonnnnn", coupon);
              return   <tr key={index}>
              <td className="d-flex align-items-center">
                <span className="me-2">
                  {copiedIndex === index ? (
                    <span className="text-success">Copied!</span>
                  ) : (
                    <span className="text-monospace">{showCode[index] ? coupon.code : '•••••••'}</span>
                  )}
                </span>
                <button
                  className="btn btn-sm btn-outline-secondary me-1"
                  onClick={() => {
                    const updated = [...showCode];
                    updated[index] = !updated[index];
                    setShowCode(updated);
                  }}
                >
                  {showCode[index] ? 'Hide' : 'Show'}
                </button>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => handleCopy(index, coupon.code)}
                >
                  Copy
                </button>
              </td>

              <td>{coupon.createdBy}</td>
              <td>{new Date(coupon.createdAt).toLocaleString()}</td>
              <td>{new Date(coupon.expiresAt).toLocaleString()}</td>
              <td>{coupon.maxUses}</td>
            </tr>
            }
            
            )}
          </tbody>
        </table>
      </div>

      {/* Create Coupon Modal */}
      {showCreateForm && (
        <div className="modal show d-block" tabIndex={-1} style={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backgroundImage: 'linear-gradient(45deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5))',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10500
        }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create New Coupon</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCreateForm(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleCreateCoupon}>

                  <div className="mb-3">
                    <label htmlFor="expiresAt" className="form-label">Expiry Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="expiresAt"
                      value={newCoupon.expiresAt}
                      onChange={(e) => setNewCoupon({ ...newCoupon, expiresAt: e.target.value })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="maxUses" className="form-label">Maximum Uses</label>
                    <input
                      type="number"
                      className="form-control"
                      id="maxUses"
                      value={newCoupon.maxUses}
                      onChange={(e) => setNewCoupon({ ...newCoupon, maxUses: parseInt(e.target.value) })}
                      min="1"
                      required
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowCreateForm(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? 'Creating...' : 'Create Coupon'}
                    </button>
                  </div>
                </form>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponManagement; 